import "./toastrConfig";

import "../css/site.less";
import "toastr/build/toastr.min.css";

import * as moment from "moment";
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/pt";
import "moment/locale/nl";
import "moment/locale/en-gb";

import * as $ from "jquery";
import "bootstrap-datepicker";
import "eonasdan-bootstrap-datetimepicker";
import * as _ from "lodash";
import * as ko from "knockout";
import * as ksb from "knockout-secure-binding";
var options = {
  attribute: "data-bind", // default "data-sbind"
  globals: window, // default {}
  bindings: ko.bindingHandlers, // default ko.bindingHandlers
  noVirtualElements: false, // default true
};
ko.bindingProvider.instance = new ksb(options);

var logoText = require("../insidelogic.txt");
console.info(logoText.default);
_.each(moment.locales(), (locale) => {
  ($.fn as any).datepicker.dates[locale] = {
    days: moment.localeData(locale).weekdays(),
    daysShort: moment.localeData(locale).weekdaysShort(),
    daysMin: moment.localeData(locale).weekdaysMin(),
    months: moment.localeData(locale).months(),
    monthsShort: moment.localeData(locale).monthsShort(),
    today: "Today",
    clear: "Clear",
    format: moment.localeData(locale).longDateFormat("L").replace("YYYY", "yyyy"),
    titleFormat: "MM yyyy" /* Leverages same syntax as 'format' */,
    weekStart: 0,
  };
});

let en = moment.locale("en-GB");
moment.locale("en-GB");
